export class StringHelper {
    static isNullOrEmpty(s: string): boolean {
        if (!s) {
            return true;
        } else {
            if (s.trim() === "") {
                return true;
            }
            return false;
        }
    }

    static removeAccents(s: any): string {
        s = s.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        s = s.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        s = s.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        s = s.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        s = s.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        s = s.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        s = s.replace(/đ/g, "d");
        s = s.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
        s = s.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
        s = s.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
        s = s.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
        s = s.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
        s = s.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
        s = s.replace(/Đ/g, "D");
        // combining Diacritical Marks
        s = s.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // huyền, sắc, hỏi, ngã, nặng
        s = s.replace(/\u02C6|\u0306|\u031B/g, ""); // mũ â (ê), mũ ă, mũ ơ (ư)
    
        return s;
      }
    
      static codeAndUsernameValidate(s : any): string {
        s = s.replace(/[`~!@#$%^&*():;'"|\\\[\]\{\}\+=<>\.,\/\?\s]/g, "");
        return s;
      }
}